import { render, staticRenderFns } from "./FooterNavigation.vue?vue&type=template&id=272004d1&scoped=true&"
import script from "./FooterNavigation.vue?vue&type=script&lang=ts&"
export * from "./FooterNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./FooterNavigation.vue?vue&type=style&index=0&id=272004d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272004d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBottomNavigation,VBtn,VIcon,VSpacer})
